/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {AccountModel} from "../../models/account-model";

export interface AccountDetailsGetParams {
    accountGuid: string;
}

export function accountDetailsGet(http: HttpClient, rootUrl: string, params: AccountDetailsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<AccountModel>> {
    const rb = new RequestBuilder(rootUrl, accountDetailsGet.PATH, 'get');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params.accountGuid) {
        rb.path('accountGuid', params.accountGuid, { 'style': 'simple' });
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<AccountModel>;
        })
    );
}

accountDetailsGet.PATH = '/api/v1/accounts/{accountGuid}/details';
